import { useEffect, useState } from 'react';
import api from '../lib/api';

let cached = null;
let cachedAt = 0;
const CACHE_TTL_MS = 30 * 1000;

export default function useSiteBootstrap() {
  const [data, setData] = useState(cached);

  useEffect(() => {
    if (cached && Date.now() - cachedAt < CACHE_TTL_MS) return;
    api.get('/public/site/')
      .then((res) => {
        cached = res.data;
        cachedAt = Date.now();
        setData(res.data);
      })
      .catch(() => {
        setData({ settings: null, menu_pages: [], footer_pages: [] });
      });
  }, []);

  useEffect(() => {
    const settings = data?.settings || {};
    if (!settings) return;
    const root = document.documentElement;
    if (settings.primary_color) root.style.setProperty('--brand-primary', settings.primary_color);
    if (settings.secondary_color) root.style.setProperty('--brand-secondary', settings.secondary_color);
  }, [data]);

  return data;
}
